"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminUserActionDtoActionEnum = void 0;
exports.instanceOfAdminUserActionDto = instanceOfAdminUserActionDto;
exports.AdminUserActionDtoFromJSON = AdminUserActionDtoFromJSON;
exports.AdminUserActionDtoFromJSONTyped = AdminUserActionDtoFromJSONTyped;
exports.AdminUserActionDtoToJSON = AdminUserActionDtoToJSON;
exports.AdminUserActionDtoToJSONTyped = AdminUserActionDtoToJSONTyped;
/**
 * @export
 */
exports.AdminUserActionDtoActionEnum = {
    Disable: 'disable',
    Enable: 'enable',
    Delete: 'delete'
};
/**
 * Check if a given object implements the AdminUserActionDto interface.
 */
function instanceOfAdminUserActionDto(value) {
    if (!('action' in value) || value['action'] === undefined)
        return false;
    return true;
}
function AdminUserActionDtoFromJSON(json) {
    return AdminUserActionDtoFromJSONTyped(json, false);
}
function AdminUserActionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'userId': json['userId'] == null ? undefined : json['userId'],
        'action': json['action'],
    };
}
function AdminUserActionDtoToJSON(json) {
    return AdminUserActionDtoToJSONTyped(json, false);
}
function AdminUserActionDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'userId': value['userId'],
        'action': value['action'],
    };
}
